export default {
  isoName: 'zh-hans',
  nativeName: '中文(简体)',
  measure: {
    distance: '距离',
    area: '面积',
    horizontalDistance: '水平距离',
    spaceDistance: '空间距离',
    verticalHeight: '垂直高度'
  },
  draw: {
    drawingTip1: '单击左键绘制起点。',
    drawingTip2: '单击左键绘制下一个点，单击右键结束绘制。',
    drawingTip3: '单击结束编辑。',
    editingMove: '移动节点',
    editingInsert: '插入节点',
    editingDelete: '删除节点'
  },
  navigation: {
    compass: {
      description: '拖拽罗盘外环: 旋转视图。\n拖拽罗盘陀螺仪: 翻转视图。\n双击罗盘: 重置视图。\n提示: 您也可以通过按住Ctrl键的同时拖拽地图来改变地图倾角。',
      title: '旋转相机'
    },
    zoomCotrol: {
      zoomIn: '放大',
      zoomReset: '重置视图',
      zoomOut: '缩小'
    },
    legend: {
      lat: '纬度',
      lon: '经度',
      zone: '带号',
      e: 'X',
      n: 'Y',
      elev: '高程',
      cameraHeight: '相机高度'
    },
    printView: '打印分享',
    centreMap: '定位您的位置'
  },
  overviewmap: {
    show: '显示鹰眼',
    hidden: '隐藏鹰眼'
  }
}
